import React, { useContext, useEffect, useState } from 'react';

//import { useParams } from 'hooks/useParams';
import { toJS } from 'mobx';
import { CeoSurvey as CeoEnrollmentFormType } from 'models/CeoSurvey';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { CeoSubmittedFormInstance } from 'services/ceoSubmittedForm';
import { EnrollmentFormServiceInstance } from 'services/enrollmentFormService';
import { CeoEnrollmentFormContext } from 'store/CeoSurvey';
import { AllErrors, NotFoundError } from 'types/Errors';

import { questions } from './CeoSurvey.constants';
import { Params, CeoSurveyGeneratedProps } from './CeoSurvey.props';
import { ceoSurveyToSubmittedForm } from './CeoSurvey.transform';
import CeoEnrollmentFormView from './CeoSurvey.view';

const CeoSurvey = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };

  // MARK:- Store
  //const CeoEnrollmentFormStore = useContext(CeoEnrollmentFormContext);

  // MARK:- State
  const [page, setPage] = useState<number>(1);
  const [enrollmentForm, setEnrollmentForm] = useState<CeoEnrollmentFormType>(
    questions
  );

  const enrollmentFormQuery = useQuery(
    ['EnrollmentId', id],
    () => EnrollmentFormServiceInstance.getById(id),
    {
      enabled: !!id,
      onSuccess: () => {
        // NOTHINGS
      },
      onError: (error: AllErrors) => {
        navigate('/not-found');
      },
    }
  );

  const questionsQuery = useQuery(
    ['enrollmentId', id],
    () => CeoSubmittedFormInstance.getByEnrollmentId(id),
    {
      enabled: !!id,
      onSuccess: () => {
      //NOTHING
      },
      onError: (error: AllErrors) => {
        //navigate('/not-found');
      }
    }
  );

  // MARK:- Mutations
  const submitCeoSurvey = useMutation(
    CeoSubmittedFormInstance.createCeoSubmittedForm,
    {
      onSuccess: (data) => {
        navigate('/success');
      },
      onError: (error: AllErrors) => {
        console.error(error);
      },
    }
  );

  // MARK:- Functions
  function onChangeInput(value: string, ndx: number) {
    const newEnrollmentForm = [...enrollmentForm];
    newEnrollmentForm[ndx].value = value;

    setEnrollmentForm(newEnrollmentForm);
    //CeoEnrollmentFormStore.onChangeCeoSurvey(newEnrollmentForm);
  }

  function onClickNext() {
    setPage(2);
  }

  function onSubmitForm() {
    submitCeoSurvey.mutate(
      ceoSurveyToSubmittedForm(toJS(enrollmentForm), id)
    );
  }

  useEffect(() => {
    //if (CeoEnrollmentFormStore.ceoSurvey.length === 0) {
    //  console.log('questions: ', questions)
    //  setEnrollmentForm(questions);
    //} else {
    //  console.log('surveyId: ', id, 'ceoSurvey: ', CeoEnrollmentFormStore.ceoSurvey)
    //  setEnrollmentForm(CeoEnrollmentFormStore.ceoSurvey);
    //}
    if (questionsQuery.data?.body) {
      setEnrollmentForm(questionsQuery.data?.body?.questions);
    } else {
      setEnrollmentForm(questions);
    }
  }, [questionsQuery]);

  const generatedProps: CeoSurveyGeneratedProps = {
    // generated props here
    isFetching: questionsQuery.isLoading,
    isSubmitting: submitCeoSurvey.isLoading,
    onClickNext,
    onClickSubmit: onSubmitForm,
    onChangeInput,
    enrollmentForm
  };
  return <CeoEnrollmentFormView {...generatedProps} />;
};

export default CeoSurvey;
